import { render, staticRenderFns } from "./AllAccountsKyc.vue?vue&type=template&id=cf357972&scoped=true"
import script from "./AllAccountsKyc.vue?vue&type=script&lang=js"
export * from "./AllAccountsKyc.vue?vue&type=script&lang=js"
import style0 from "./AllAccountsKyc.vue?vue&type=style&index=0&id=cf357972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf357972",
  null
  
)

export default component.exports